import React from "react";
import { Button, Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import { ModalProvider, useModalContext } from "common/contexts";
import useFeature from "hooks/useFeature";
import PageDescription from "./PageDescription";
import List from "./List";
import DetectionChainsModals from "./DetectionChainsModals";
import { DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG } from "./constants";
const CreateChainButton = () => {
  const { setModal, setEntity } = useModalContext();
  const managementEnabled = useFeature(DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG);
  if (!managementEnabled) return null;
  const onCreate = () => {
    setEntity(null);
    setModal("CREATE-CHAIN");
  };
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onCreate }, "Create Detection Chain");
};
const DetectionChainsPage = ({ navigationComponent = null }) => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Detection Chains" }, /* @__PURE__ */ React.createElement(ModalProvider, null, navigationComponent, /* @__PURE__ */ React.createElement(PageHeader, { title: "Detection Chains", actions: /* @__PURE__ */ React.createElement(CreateChainButton, null) }, /* @__PURE__ */ React.createElement(PageDescription, null)), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(List, null))), /* @__PURE__ */ React.createElement(DetectionChainsModals, null)));
export default DetectionChainsPage;
